namespace $ {

	/** At most 64 summary-page references in a separate inherited area. */
	export class $shm_hitalama_map_history_storage_target_writer_chunk extends $giper_baza_entity.with({
		Packed: $giper_baza_atom_dict,
	}) {
		@ $mol_mem
		private loading() {
			return { promise: new $mol_promise_blocker<void>() }
		}

		packed( next?: { v: number, previous: string, items: readonly string[], before?: readonly (number | null)[] } ) {
			if( next === undefined ) return this.packed_ready()
			const packed = this.packed_validate( next )
			this.Packed( null )!.val( next )
			return packed
		}

		@ $mol_mem
		packed_ready() {
			this.keys()
			const atom = this.Packed()
			// The reference head and this area arrive independently. Subscribe to
			// keys before suspending, so remote arrival wakes this reader without
			// polling or treating an unfinished download as corrupt data.
			// Keep the entire readiness check in a live atom. An action otherwise
			// captures an empty keys() snapshot before waiting and cannot reread it.
			if( !atom ) $mol_fail_hidden( this.loading().promise )
			return this.packed_validate( atom?.val() )
		}

		private packed_validate( packed: any ) {
			if( !packed || packed.v !== 1 || typeof packed.previous !== 'string'
				|| !Array.isArray( packed.items ) || packed.items.length > 64
				|| packed.items.some( ( item: unknown )=> typeof item !== 'string' )
				|| (packed.before !== undefined && (!Array.isArray(packed.before)
					|| packed.before.length !== packed.items.length
					|| packed.before.some( ( value: unknown )=> value !== null && (typeof value !== 'number' || !Number.isFinite(value)) ))) ) {
				throw new Error( 'Не загружен или повреждён блок ссылок истории' )
			}
			if( $mol_charset_encode( JSON.stringify( packed ) ).byteLength > 48000 ) {
				throw new Error( 'Блок ссылок истории превышает допустимый размер' )
			}
			return packed as { v: number, previous: string, items: readonly string[], before?: readonly (number | null)[] }
		}

	}

}
